export default "__VITE_ASSET__D2V4sn1K__"